import { inject, injectable } from 'inversify'
import { TYPES } from '@/libs/di/types'

import type { UserID, KarteID } from '@/types/app'
import type { UserUsecase } from '@/apis/usecases'
import type { UserRepository } from '@/apis/usecases/dataAccesses'

@injectable()
export class UserInteractor implements UserUsecase {
  @inject(TYPES.UserRepository) private _userRepository: UserRepository

  public async getDiagnosisSummary(userId: UserID) {
    return this._userRepository.getDiagnosisSummary(userId)
  }
  public async getDiagnosisSummaryByKarteId(karteId: KarteID) {
    return this._userRepository.getDiagnosisSummaryByKarteId(karteId)
  }
}
